<template>
    <div class="pt-15 animated fadeIn staticPageInner equipmentList bgV2">
        <div class="boxShadow setBorderRadius heig-frame-equipment-group">
            <b-row no-gutters>
                <b-col md="12" class="heig-frame-child">
                    <gofix-card title=" " classHeader="p-0 m-0" class="heig-frame-child" fullContent>
                        <!-- @row-click="openModal"
                            @new-item="openModal" -->
                        <gofix-table
                            class="noFullHeight scrollAbsolute"
                            :settings="tableConfig"
                            :table-items="tableItems"
                            @load-items="getTableData"
                            @clone-master="showModalClone"
                            @delete-items="deleteItems"
                            ref="gofixTable">
                        </gofix-table>
                        <b-modal :no-close-on-backdrop="true" modal-class="createFmCode" id="modal-Create" :title="modal.title" hide-footer :centered="true" v-model="modal.open">
                            <b-form class="pb-20">
                                <gofix-form-input label="Requestor Type" v-model="modal.data.title" required></gofix-form-input>
                                <gofix-form-dropdown
                                    label="Requestor Data Type"
                                    :clearable="true"
                                    :required="true"
                                    :show-icon-required="true"
                                    v-model="modal.data.data_type"
                                    :options="modal.requestorDataType">
                                </gofix-form-dropdown>
                            </b-form>
                            <b-button-group class="d-block text-right">
                                <gofix-button label="SUBMIT" @click="save" :loading="modal.loading" noBorder></gofix-button>
                            </b-button-group>
                        </b-modal>
                        <b-modal :no-close-on-backdrop="true" @hidden="hideModel" id="modal-Clone"
                            modal-class="default-modal modal-clone-notification"
                            title="Clone Master"
                            :centered="true"
                            scrollable
                            :footer-class="'border-0'"
                            v-model="modalClone.open">
                            <b-form v-if="modalClone.list.length">
                                <ul class="listCheck list-unstyled listData">
                                    <li>
                                        <input class="styled-checkbox" type="checkbox" v-model="modalClone.allSelect">
                                        <label></label>
                                        <span class="pl-25">Requestor Type</span>
                                    </li>
                                    <template  v-for="(cl, index) in modalClone.list">
                                        <li :key="index">
                                            <input v-model="modalClone.select" class="styled-checkbox" type="checkbox" :value="cl.id">
                                            <label></label>
                                            <span>{{index + 1}}</span>
                                            <span>{{cl.title}}</span>
                                        </li>
                                    </template>
                                </ul>
                            </b-form>
                            <div class="pb-20 text-center" v-if="!modalClone.list.length">
                                No Master!
                            </div>
                            <template #modal-footer>
                                <b-button-group class="d-block text-right pr-3">
                                    <gofix-button label="SUBMIT" @click="cloneDataFromMater" :loading="modalClone.loading" noBorder></gofix-button>
                                </b-button-group>
                            </template>
                        </b-modal>
                    </gofix-card>
                </b-col>
            </b-row>
        </div>
    </div>
</template>
<script>
    const defaultFields = [
        {
            key: 'avenue_of_feedback',
            label: 'Avenue Of Feedback',
            thStyle: "width:100px",
            isActive: 1,
            isFilter: false,
            sorting: false
        },
        {
            key: 'priority',
            label: 'Priority',
            thStyle: "width:100px",
            isActive: 1,
            isFilter: false,
            sorting: false
        },
        {
            key: 'received_time',
            label: 'Received Time',
            isActive: 1,
            thStyle: "width:150px",
            isFilter: false,
            sorting: false
        },
        {
            key: 'criteria',
            label: 'Criteria (SLA)',
            isActive: 1,
            thStyle: "width:150px",
            isFilter: false,
            sorting: false
        },
        {
            key: 'deadline',
            label: 'Deadline (SLA/KPI)',
            isActive: 1,
            thStyle: "width:200px",
            isFilter: false,
            sorting: false
        }
    ];

    const defaultDataItems = [
        // QP email - Normal - During OP hours: 9AM-5PM
        {
            avenue_of_feedback: 'QP email',
            priority: 'Normal',
            received_time: 'During OP hours: 9AM-5PM',
            criteria: 'FCR reply to requestor',
            deadline: 'Within the day'
        },
        {
            avenue_of_feedback: 'QP email',
            priority: 'Normal',
            received_time: 'During OP hours: 9AM-5PM',
            criteria: 'First NFCR reply to requestor',
            deadline: 'Within the day'
        },
        {
            avenue_of_feedback: 'QP email',
            priority: 'Normal',
            received_time: 'During OP hours: 9AM-5PM',
            criteria: 'Interim NFCR reply to requestor',
            deadline: 'Within 2 business days'
        },
        {
            avenue_of_feedback: 'QP email',
            priority: 'Normal',
            received_time: 'During OP hours: 9AM-5PM',
            criteria: 'Final NFCR reply to requestor',
            deadline: 'Within 4 hours'
        },
        {
            avenue_of_feedback: 'QP email',
            priority: 'Normal',
            received_time: 'During OP hours: 9AM-5PM',
            criteria: 'Escalation to stakeholder',
            deadline: 'By 6pm same day'
        },
        {
            avenue_of_feedback: 'QP email',
            priority: 'Normal',
            received_time: 'During OP hours: 9AM-5PM',
            criteria: '1st reminder to stakeholder',
            deadline: 'Within 2 business days'
        },
        {
            avenue_of_feedback: 'QP email',
            priority: 'Normal',
            received_time: 'During OP hours: 9AM-5PM',
            criteria: '2nd reminder to stakeholder',
            deadline: 'Next business day'
        },
        {
            avenue_of_feedback: 'QP email',
            priority: 'Normal',
            received_time: 'During OP hours: 9AM-5PM',
            criteria: '3rd reminder to stakeholder',
            deadline: 'Next business day'
        },
        {
            avenue_of_feedback: 'QP email',
            priority: 'Normal',
            received_time: 'During OP hours: 9AM-5PM',
            criteria: '4th reminder to stakeholder',
            deadline: 'Next business day'
        },
        {
            avenue_of_feedback: 'QP email',
            priority: 'Normal',
            received_time: 'During OP hours: 9AM-5PM',
            criteria: 'Retrieval of stakeholder response',
            deadline: 'Within 1 business days'
        },
        // QP email - Normal - Off OP hours
        {
            avenue_of_feedback: 'QP email',
            priority: 'Normal',
            received_time: 'Off OP hours',
            criteria: 'FCR reply to requestor',
            deadline: 'By 11AM next business day'
        },
        {
            avenue_of_feedback: 'QP email',
            priority: 'Normal',
            received_time: 'Off OP hours',
            criteria: 'First NFCR reply to requestor',
            deadline: 'By 11AM next business day'
        },
        {
            avenue_of_feedback: 'QP email',
            priority: 'Normal',
            received_time: 'Off OP hours',
            criteria: 'Interim NFCR reply to requestor',
            deadline: 'Within 2 business days'
        },
        {
            avenue_of_feedback: 'QP email',
            priority: 'Normal',
            received_time: 'Off OP hours',
            criteria: 'Final NFCR reply to requestor',
            deadline: 'By 11AM next business day'
        },
        {
            avenue_of_feedback: 'QP email',
            priority: 'Normal',
            received_time: 'Off OP hours',
            criteria: 'Escalation to stakeholder',
            deadline: 'By 11AM next business day'
        },
        {
            avenue_of_feedback: 'QP email',
            priority: 'Normal',
            received_time: 'Off OP hours',
            criteria: '1st reminder to stakeholder',
            deadline: 'Within 2 business days'
        },
        {
            avenue_of_feedback: 'QP email',
            priority: 'Normal',
            received_time: 'Off OP hours',
            criteria: '2nd reminder to stakeholder',
            deadline: 'Next business day'
        },
        {
            avenue_of_feedback: 'QP email',
            priority: 'Normal',
            received_time: 'Off OP hours',
            criteria: '3rd reminder to stakeholder',
            deadline: 'Next business day'
        },
        {
            avenue_of_feedback: 'QP email',
            priority: 'Normal',
            received_time: 'Off OP hours',
            criteria: '4th reminder to stakeholder',
            deadline: 'Next business day'
        },
        {
            avenue_of_feedback: 'QP email',
            priority: 'Normal',
            received_time: 'Off OP hours',
            criteria: 'Retrieval of stakeholder response',
            deadline: 'Within 1 business days'
        },
        // QP email - Urgent - During OP hours: 9AM-5PM
        {
            avenue_of_feedback: 'QP email',
            priority: 'Urgent',
            received_time: 'During OP hours: 9AM-5PM',
            criteria: 'FCR reply to requestor',
            deadline: 'Within 2 hours'
        },
        {
            avenue_of_feedback: 'QP email',
            priority: 'Urgent',
            received_time: 'During OP hours: 9AM-5PM',
            criteria: 'First NFCR reply to requestor',
            deadline: 'Within 2 hours'
        },
        {
            avenue_of_feedback: 'QP email',
            priority: 'Urgent',
            received_time: 'During OP hours: 9AM-5PM',
            criteria: 'Interim NFCR reply to requestor',
            deadline: 'Within 1 business days'
        },
        {
            avenue_of_feedback: 'QP email',
            priority: 'Urgent',
            received_time: 'During OP hours: 9AM-5PM',
            criteria: 'Final NFCR reply to requestor',
            deadline: 'Within 3 hours'
        },
        {
            avenue_of_feedback: 'QP email',
            priority: 'Urgent',
            received_time: 'During OP hours: 9AM-5PM',
            criteria: 'Escalation to stakeholder',
            deadline: 'Within 2 hours'
        },
        {
            avenue_of_feedback: 'QP email',
            priority: 'Urgent',
            received_time: 'During OP hours: 9AM-5PM',
            criteria: '1st reminder to stakeholder',
            deadline: 'Next business day'
        },
        {
            avenue_of_feedback: 'QP email',
            priority: 'Urgent',
            received_time: 'During OP hours: 9AM-5PM',
            criteria: '2nd reminder to stakeholder',
            deadline: 'Next business day'
        },
        {
            avenue_of_feedback: 'QP email',
            priority: 'Urgent',
            received_time: 'During OP hours: 9AM-5PM',
            criteria: '3rd reminder to stakeholder',
            deadline: 'Next business day'
        },
        {
            avenue_of_feedback: 'QP email',
            priority: 'Urgent',
            received_time: 'During OP hours: 9AM-5PM',
            criteria: '4th reminder to stakeholder',
            deadline: 'Next business day'
        },
        {
            avenue_of_feedback: 'QP email',
            priority: 'Urgent',
            received_time: 'During OP hours: 9AM-5PM',
            criteria: 'Retrieval of stakeholder response',
            deadline: 'Within the day'
        },
        // QP email - Urgent - Off OP hours
        {
            avenue_of_feedback: 'QP email',
            priority: 'Urgent',
            received_time: 'Off OP hours',
            criteria: 'FCR reply to requestor',
            deadline: 'By 11AM next business day'
        },
        {
            avenue_of_feedback: 'QP email',
            priority: 'Urgent',
            received_time: 'Off OP hours',
            criteria: 'First NFCR reply to requestor',
            deadline: 'By 11AM next business day'
        },
        {
            avenue_of_feedback: 'QP email',
            priority: 'Urgent',
            received_time: 'Off OP hours',
            criteria: 'Interim NFCR reply to requestor',
            deadline: 'Within 1 business day'
        },
        {
            avenue_of_feedback: 'QP email',
            priority: 'Urgent',
            received_time: 'Off OP hours',
            criteria: 'Final NFCR reply to requestor',
            deadline: 'By 11AM next business day'
        },
        {
            avenue_of_feedback: 'QP email',
            priority: 'Urgent',
            received_time: 'Off OP hours',
            criteria: 'Escalation to stakeholder',
            deadline: 'By 11AM next business day'
        },
        {
            avenue_of_feedback: 'QP email',
            priority: 'Urgent',
            received_time: 'Off OP hours',
            criteria: '1st reminder to stakeholder',
            deadline: 'Next business day'
        },
        {
            avenue_of_feedback: 'QP email',
            priority: 'Urgent',
            received_time: 'Off OP hours',
            criteria: '2nd reminder to stakeholder',
            deadline: 'Next business day'
        },
        {
            avenue_of_feedback: 'QP email',
            priority: 'Urgent',
            received_time: 'Off OP hours',
            criteria: '3rd reminder to stakeholder',
            deadline: 'Next business day'
        },
        {
            avenue_of_feedback: 'QP email',
            priority: 'Urgent',
            received_time: 'Off OP hours',
            criteria: '4th reminder to stakeholder',
            deadline: 'Next business day'
        },
        {
            avenue_of_feedback: 'QP email',
            priority: 'Urgent',
            received_time: 'Off OP hours',
            criteria: 'Retrieval of stakeholder response',
            deadline: 'Within the day'
        },
        // ASK Emails - Normal
        {
            avenue_of_feedback: 'ASK Emails',
            priority: 'Normal',
            received_time: 'Anytime',
            criteria: 'FCR reply to requestor',
            deadline: 'Within 3 business days'
        },
        {
            avenue_of_feedback: 'ASK Emails',
            priority: 'Normal',
            received_time: 'Anytime',
            criteria: 'First NFCR reply to requestor',
            deadline: 'Within 3 business days'
        },
        {
            avenue_of_feedback: 'ASK Emails',
            priority: 'Normal',
            received_time: 'Anytime',
            criteria: 'Interim NFCR reply to requestor',
            deadline: ''
        },
        {
            avenue_of_feedback: 'ASK Emails',
            priority: 'Normal',
            received_time: 'Anytime',
            criteria: 'Final NFCR reply to requestor',
            deadline: 'Within 1 business days'
        },
        {
            avenue_of_feedback: 'ASK Emails',
            priority: 'Normal',
            received_time: 'Anytime',
            criteria: 'Escalation to stakeholder',
            deadline: 'Within 1 business days'
        },
        {
            avenue_of_feedback: 'ASK Emails',
            priority: 'Normal',
            received_time: 'Anytime',
            criteria: '1st reminder to stakeholder',
            deadline: 'Within 2 business days'
        },
        {
            avenue_of_feedback: 'ASK Emails',
            priority: 'Normal',
            received_time: 'Anytime',
            criteria: '2nd reminder to stakeholder',
            deadline: 'Next business day'
        },
        {
            avenue_of_feedback: 'ASK Emails',
            priority: 'Normal',
            received_time: 'Anytime',
            criteria: '3rd reminder to stakeholder',
            deadline: 'Next business day'
        },
        {
            avenue_of_feedback: 'ASK Emails',
            priority: 'Normal',
            received_time: 'Anytime',
            criteria: '4th reminder to stakeholder',
            deadline: 'Next business day'
        },
        {
            avenue_of_feedback: 'ASK Emails',
            priority: 'Normal',
            received_time: 'Anytime',
            criteria: 'Retrieval of stakeholder response',
            deadline: 'Within 2 business days'
        },
        // ASK Emails - Urgent
        {
            avenue_of_feedback: 'ASK Emails',
            priority: 'Urgent',
            received_time: 'Anytime',
            criteria: 'FCR reply to requestor',
            deadline: 'Within 1 business days'
        },
        {
            avenue_of_feedback: 'ASK Emails',
            priority: 'Urgent',
            received_time: 'Anytime',
            criteria: 'First NFCR reply to requestor',
            deadline: 'Within 1 business days'
        },
        {
            avenue_of_feedback: 'ASK Emails',
            priority: 'Urgent',
            received_time: 'Anytime',
            criteria: 'Interim NFCR reply to requestor',
            deadline: ''
        },
        {
            avenue_of_feedback: 'ASK Emails',
            priority: 'Urgent',
            received_time: 'Anytime',
            criteria: 'Final NFCR reply to requestor',
            deadline: 'Within 1 business days'
        },
        {
            avenue_of_feedback: 'ASK Emails',
            priority: 'Urgent',
            received_time: 'Anytime',
            criteria: 'Escalation to stakeholder',
            deadline: 'Within the day'
        },
        {
            avenue_of_feedback: 'ASK Emails',
            priority: 'Urgent',
            received_time: 'Anytime',
            criteria: '1st reminder to stakeholder',
            deadline: 'Next business day'
        },
        {
            avenue_of_feedback: 'ASK Emails',
            priority: 'Urgent',
            received_time: 'Anytime',
            criteria: '2nd reminder to stakeholder',
            deadline: 'Next business day'
        },
        {
            avenue_of_feedback: 'ASK Emails',
            priority: 'Urgent',
            received_time: 'Anytime',
            criteria: '3rd reminder to stakeholder',
            deadline: 'Next business day'
        },
        {
            avenue_of_feedback: 'ASK Emails',
            priority: 'Urgent',
            received_time: 'Anytime',
            criteria: '4th reminder to stakeholder',
            deadline: 'Next business day'
        },
        {
            avenue_of_feedback: 'ASK Emails',
            priority: 'Urgent',
            received_time: 'Anytime',
            criteria: 'Retrieval of stakeholder response',
            deadline: 'Within the day'
        },
        // Inbound Calls - Normal
        {
            avenue_of_feedback: 'Inbound Calls',
            priority: 'Normal',
            received_time: 'Anytime',
            criteria: 'FCR reply to requestor',
            deadline: 'Within 3 business days'
        },
        {
            avenue_of_feedback: 'Inbound Calls',
            priority: 'Normal',
            received_time: 'Anytime',
            criteria: 'First NFCR reply to requestor',
            deadline: 'Within 3 business days'
        },
        {
            avenue_of_feedback: 'Inbound Calls',
            priority: 'Normal',
            received_time: 'Anytime',
            criteria: 'Interim NFCR reply to requestor',
            deadline: ''
        },
        {
            avenue_of_feedback: 'Inbound Calls',
            priority: 'Normal',
            received_time: 'Anytime',
            criteria: 'Final NFCR reply to requestor',
            deadline: 'Within 1 business days'
        },
        {
            avenue_of_feedback: 'Inbound Calls',
            priority: 'Normal',
            received_time: 'Anytime',
            criteria: 'Escalation to stakeholder',
            deadline: 'Within 1 business days'
        },
        {
            avenue_of_feedback: 'Inbound Calls',
            priority: 'Normal',
            received_time: 'Anytime',
            criteria: '1st reminder to stakeholder',
            deadline: 'Within 2 business days'
        },
        {
            avenue_of_feedback: 'Inbound Calls',
            priority: 'Normal',
            received_time: 'Anytime',
            criteria: '2nd reminder to stakeholder',
            deadline: 'Next business day'
        },
        {
            avenue_of_feedback: 'Inbound Calls',
            priority: 'Normal',
            received_time: 'Anytime',
            criteria: '3rd reminder to stakeholder',
            deadline: 'Next business day'
        },
        {
            avenue_of_feedback: 'Inbound Calls',
            priority: 'Normal',
            received_time: 'Anytime',
            criteria: '4th reminder to stakeholder',
            deadline: 'Next business day'
        },
        {
            avenue_of_feedback: 'Inbound Calls',
            priority: 'Normal',
            received_time: 'Anytime',
            criteria: 'Retrieval of stakeholder response',
            deadline: 'Within 2 business days'
        },
        // Inbound Calls - Urgent
        {
            avenue_of_feedback: 'Inbound Calls',
            priority: 'Urgent',
            received_time: 'Anytime',
            criteria: 'FCR reply to requestor',
            deadline: 'Within 1 business days'
        },
        {
            avenue_of_feedback: 'Inbound Calls',
            priority: 'Urgent',
            received_time: 'Anytime',
            criteria: 'First NFCR reply to requestor',
            deadline: 'Within 1 business days'
        },
        {
            avenue_of_feedback: 'Inbound Calls',
            priority: 'Urgent',
            received_time: 'Anytime',
            criteria: 'Interim NFCR reply to requestor',
            deadline: ''
        },
        {
            avenue_of_feedback: 'Inbound Calls',
            priority: 'Urgent',
            received_time: 'Anytime',
            criteria: 'Final NFCR reply to requestor',
            deadline: 'Within 1 business days'
        },
        {
            avenue_of_feedback: 'Inbound Calls',
            priority: 'Urgent',
            received_time: 'Anytime',
            criteria: 'Escalation to stakeholder',
            deadline: 'Within the day'
        },
        {
            avenue_of_feedback: 'Inbound Calls',
            priority: 'Urgent',
            received_time: 'Anytime',
            criteria: '1st reminder to stakeholder',
            deadline: 'Next business day'
        },
        {
            avenue_of_feedback: 'Inbound Calls',
            priority: 'Urgent',
            received_time: 'Anytime',
            criteria: '2nd reminder to stakeholder',
            deadline: 'Next business day'
        },
        {
            avenue_of_feedback: 'Inbound Calls',
            priority: 'Urgent',
            received_time: 'Anytime',
            criteria: '3rd reminder to stakeholder',
            deadline: 'Next business day'
        },
        {
            avenue_of_feedback: 'Inbound Calls',
            priority: 'Urgent',
            received_time: 'Anytime',
            criteria: '4th reminder to stakeholder',
            deadline: 'Next business day'
        },
        {
            avenue_of_feedback: 'Inbound Calls',
            priority: 'Urgent',
            received_time: 'Anytime',
            criteria: 'Retrieval of stakeholder response',
            deadline: 'Within the day'
        },
    ];
    export default {
        name: 'case-sla',
        data () {
            return {
                tableConfig:{
                    name: 'case-sla',
                    controls:{
                        create: false,
                        delete: false,
                        tableImport:false,
                        tableExport:false,
                        tableColumnSettings:false,
                        tablePagination: false,
                        tableFilter: false
                    },
                    filter: {},
                    page: 1,
                    total: 0,
                    isCMS: 'true',
                    useDatabaseView: false,
                    sortColumn: "id",
                    sortDirection: "asc",
                    fields: defaultFields
                },
                tableItems: defaultDataItems,
                modal: {
                    open: false,
                    loading: false,
                    title:"New Requester Type",
                    requestorDataType: ["Generic Address", "Company Profile", "Supplier", "Client", "FM Company",  "User Account", "Tenant", "NLT Caller Profile"],
                    data:{
                        id: null,
                        title: null,
                        data_type: null,
                        contract_id: null,
                    },
                },
                modalClone : {
                    open: false,
                    allSelect: false,
                    list:[],
                    select:[]
                }
            }
        },
        watch: {
            "modalClone.allSelect": function(val) {
                if (val) {
                    this.modalClone.select = [];
                    for (let i in this.modalClone.list) {
                        this.modalClone.select.push(this.modalClone.list[i].id)
                    }
                }
                if(!val && this.modalClone.list.length == this.modalClone.select.length) {
                    this.modalClone.select = [];
                }
            },
            "modalClone.select": function(val) {
                if(this.modalClone.select.length > 0 && this.modalClone.list.length === this.modalClone.select.length) {
                    this.modalClone.allSelect = true;
                }else{
                    this.modalClone.allSelect = false;
                }
            }
        },
        created() {
        },
        methods:{
            //Load data list
            async getTableData(callback){
                const { tableRequest , resolve,reject } = await callback();
                this.tableConfig.total = this.tableItems.length;
                resolve({
                    items: this.tableItems,
                    total: this.tableItems.length
                });
                return;
                // await this.$store.dispatch("CaseSettingsController/getListCaseRequestorTypes", tableRequest)
                //     .then(response => {
                //         this.tableItems = response.items;
                //         this.tableConfig.total = response.total;
                //         resolve(response);
                //     })
                //     .catch(err => {
                //         this.$bvToast.toast("Can not load the data", {
                //             title: `Notification`,
                //             autoHideDelay: 3000,
                //             variant: 'danger',
                //             solid: true
                //         })
                //         reject();
                //     })
            },
            //Open modal Edit || Create data
            openModal(item){
                if(item){
                    this.modal.title = "Edit Requester Type";
                    this.modal.data = {
                        id: item.id,
                        title: item.title,
                        data_type: item.data_type,
                        contract_id: item.contract_id,
                    }
                }else{
                    this.modal.title = "New Requester Type";
                    this.modal.data = {
                        id: null,
                        title: null,
                        data_type: null,
                        contract_id: !this.is_master ? this.$route.params.id : null,
                    }
                }
                this.modal.open = true;
            },
            //Update & Create data
            save(){
                if(!this.modal.data.title){
                    return this.$alertNotification('Requestor type is a required field.', "danger");
                }
                if(!this.modal.data.data_type){
                    return this.$alertNotification('Requestor data type is a required field.', "danger");
                }
                this.modal.loading = true;
                let method    = 'createItemCaseRequestorTypes';
                let msg    = 'adding';
                if(this.modal.data.id) {
                    method = 'updateItemCaseRequestorTypes';
                    msg    = 'editing';
                }
                this.$store.dispatch(`CaseSettingsController/${method}`, this.modal.data)
                    .then(result => {
                        this.$alertNotification(this.$notificationV2(msg, 'case_requestor_types'));
                        this.modal.loading = false;
                        this.modal.open = false;
                        this.$refs['gofixTable'].reloadTableKeepFilter();
                    })
                    .catch(error => {
                        this.modal.loading = false;
                        if(error.response && error.response.data.error.message.error) {
                            this.$alertNotification(error.response.data.error.message.error, "danger");
                        }
                    })
            },
            //Delete data
            async deleteItems(callback){
                const { ids,filter, resolve,reject } = await callback();
                this.$store.dispatch("CaseSettingsController/deteleItemCaseRequestorTypes", ids)
                    .then(response => {
                        resolve(this.$notificationV2('deleting', 'case_requestor_types'));
                    })
                    .catch(err =>{
                        reject(err);
                    });
            },
            // Clone
            getMaster() {
                this.$store.dispatch("CaseSettingsController/getListCaseRequestorTypes", {
                    page: 1,
                    limit: -1,
                    sortColumn: "id",
                    sortDirection: "asc",
                    isCMS: 1,
                    filter: {
                        contract_id: { type: "null", value: null, function: "=", with: [] }
                    }
                })
                    .then(response => {
                        this.modalClone.list = response.items;
                    })
                    .catch(err => { })
            },
            hideModel() {
                this.modalClone.allSelect = false;
                this.modalClone.select    = [];
                this.modalClone.list      = [];
            },
            showModalClone() {
                this.getMaster();
                this.modalClone.open = true;
            },
            cloneDataFromMater() {
                this.modalClone.loading = true;
                let data = {
                    contract_id: this.$route.params.id,
                    ids: this.modalClone.select
                };
                this.$store.dispatch("CaseSettingsController/cloneMasterCaseRequestorTypes",data)
                    .then(response => {
                        this.$alertNotification("Successfully Clone");
                        this.modalClone.open = false;
                        this.modalClone.loading = false;
                        this.$refs.gofixTable.reloadTableKeepFilter();
                    })
                    .catch(error => {
                        let msg = "Clone failed!";
                        if(error.response.data && error.response.data.error && error.response.data.error.message && error.response.data.error.message.error) {
                            msg = error.response.data.error.message.error;
                        }
                        this.$alertNotification(msg, "danger");
                        this.modalClone.loading = false;
                    })
            }
        }
    }
</script>
